// Дзеркало Prisma enum AudienceKind. Контингент заняття: група / потік / підгрупа.
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const AudienceKind = {
    GROUP: 'GROUP',
    STREAM: 'STREAM',
    SUBGROUP: 'SUBGROUP',
};
/** Значення в порядку оголошення в схемі. */
export const AUDIENCE_KIND_VALUES = ['GROUP', 'STREAM', 'SUBGROUP'];
export const AUDIENCE_KIND_LABELS = {
    GROUP: 'Група',
    STREAM: 'Потік',
    SUBGROUP: 'Підгрупа',
};
//# sourceMappingURL=audience-kind.js.map